var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar"},[_vm._t("logo"),_vm._t("project"),_c('custom-bread-crumb',{attrs:{"show-icon":"","list":_vm.breadCrumbList}}),_c('div',{staticClass:"custom-content-con"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }